import React, { useState, useEffect } from "react";
import { Dropdown, Row, Nav, Tab, Modal, Button } from "react-bootstrap";
import Switch from "react-switch";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";

import PageTitle from "../../layouts/PageTitle";
import { IMAGES } from "../../constant/theme";
import { gridDataBlog } from "../staff/GridData";
import { appApi, useGetCompaniesQuery } from "../../../store/appApi";
import { toggleCompanyStatusApi } from "../../../services/company";

const theadData = [
  { heading: "Name", sortingVale: "name" },
  { heading: "Category", sortingVale: "category" },
  { heading: "City", sortingVale: "city" },
  // { heading: "Gender", sortingVale: "gender" },
  // { heading: "Education", sortingVale: "education" },
  // { heading: "Mobile", sortingVale: "mobile" },
  // { heading: "Email", sortingVale: "email" },
  // { heading: "Joining Date", sortingVale: "join" },
  // { heading: "Action", sortingVale: "action" },
];

const AllCompanies = () => {
  const dispatch = useDispatch();

  const [sort, setSortata] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [sortBy, setSortBy] = useState("updatedAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [iconData, setIconDate] = useState({ complete: false, ind: Number });
  const [certModal, setCertModal] = useState({
    show: false,
    docs: [],
    name: "",
  });
  const [togglingId, setTogglingId] = useState(null);

  const sortFieldMap = {
    name: "name",
    profession: "profession",
    gender: "gender",
    education: "qualification",
    mobile: "phone",
    email: "email",
    join: "createdAt",
  };

  // ── Debounce search input ─────────────────────────────────────────────────
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm.trim());
      setPage(1);
    }, 350);
    return () => clearTimeout(timeout);
  }, [searchTerm]);

  // ── GET: RTK Query re-fetches automatically whenever any param changes ────
  const {
    data: companiesResponse,
    isLoading,
    isFetching,
  } = useGetCompaniesQuery({
    page,
    limit: Number(sort),
    search: debouncedSearchTerm,
    sortBy,
    sortOrder,
  });

  const rawList = Array.isArray(companiesResponse?.data)
    ? companiesResponse.data
    : [];
  const pagination = companiesResponse?.pagination || {};
  const total = Number(pagination.total) || rawList.length;
  const totalPages = Number(pagination.totalPages) || 1;

  // Map raw API fields to table-compatible shape
  const companies = rawList.map((item, index) => ({
    id: item._id || item.id || String(index + 1),
    name: item.name || "-",
    profile: item.profileImageUrl || IMAGES.smallpic1,
    category: item.category || "-",
    city: item.city || "-",
    education: item.qualification || "-",
    mobile: item.phone || "-",
    email: item.email || "-",
    join: item.createdAt
      ? new Date(item.createdAt).toLocaleDateString("en-IN")
      : "-",
    companyStatus: item.companyStatus === true,
    documents: Array.isArray(item.documents) ? item.documents : [],
  }));

  const onClick = (index) => setPage(index + 1);

  const onSort = (sortingVale, ind) => {
    const backendField = sortFieldMap[sortingVale];
    if (!backendField) return;
    const nextOrder =
      sortBy === backendField && sortOrder === "asc" ? "desc" : "asc";
    setSortBy(backendField);
    setSortOrder(nextOrder);
    setPage(1);
    setIconDate({ complete: nextOrder === "asc", ind });
  };

  // ── PATCH: direct service call, then bust the RTK cache ──────────────────
  const handleToggleStatus = async (company) => {
    const newStatus = !company.companyStatus;
    setTogglingId(company.id);
    try {
      await toggleCompanyStatusApi(company.id, newStatus);
      dispatch(appApi.util.invalidateTags(["Companies"]));
    } catch (_err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update company status.",
      });
    } finally {
      setTogglingId(null);
    }
  };

  const paggination = Array(totalPages)
    .fill()
    .map((_, i) => i + 1);

  const showingFrom = total > 0 ? (page - 1) * Number(sort) + 1 : 0;
  const showingTo = total > 0 ? Math.min(page * Number(sort), total) : 0;
  const showLoading = isLoading || isFetching;

  return (
    <>
      <PageTitle activeMenu={"All Companies"} motherMenu={"Companies"} />
      <Row>
        <Tab.Container defaultActiveKey={"List"}>
          {/* <div className="col-lg-12">
            <Nav as="ul" className="nav nav-pills mb-3">
              <Nav.Item as="li">
                <Nav.Link eventKey="List" className="me-1">
                  List View
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as="li">
                <Nav.Link eventKey="Grid">Grid View</Nav.Link>
              </Nav.Item>
            </Nav>
          </div> */}
          <div className="col-lg-12">
            <Tab.Content className="row tab-content">
              <Tab.Pane eventKey="List" className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">All Consultants </h4>
                    <Link to={"/add-consultant"} className="btn btn-primary">
                      + Add New
                    </Link>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <div
                        id="holidayList"
                        className="dataTables_wrapper no-footer"
                      >
                        <div className="justify-content-between d-sm-flex">
                          <div className="dataTables_length">
                            <label className="d-flex align-items-center">
                              Show
                              <Dropdown className="search-drop">
                                <Dropdown.Toggle
                                  as="div"
                                  className="search-drop-btn"
                                >
                                  {sort}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <Dropdown.Item
                                    onClick={() => {
                                      setSortata(10);
                                      setPage(1);
                                    }}
                                  >
                                    10
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() => {
                                      setSortata(20);
                                      setPage(1);
                                    }}
                                  >
                                    20
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() => {
                                      setSortata(30);
                                      setPage(1);
                                    }}
                                  >
                                    30
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                              entries
                            </label>
                          </div>
                          {/* <div className="dataTables_filter">
                            <label>
                              Search :{" "}
                              <input
                                type="search"
                                className=""
                                placeholder=""
                                value={searchTerm}
                                onChange={(event) =>
                                  setSearchTerm(event.target.value)
                                }
                              />
                            </label>
                          </div> */}
                        </div>
                        <table
                          id="example4"
                          className="display dataTable no-footer w-100"
                        >
                          <thead>
                            <tr>
                              {theadData.map((item, ind) => (
                                <th
                                  key={ind}
                                  onClick={() => {
                                    onSort(item.sortingVale, ind);
                                  }}
                                >
                                  {item.heading}
                                  <span>
                                    {ind !== iconData.ind && (
                                      <i
                                        className="fa fa-sort ms-2 fs-12"
                                        style={{ opacity: "0.3" }}
                                      />
                                    )}
                                    {ind === iconData.ind &&
                                      (iconData.complete ? (
                                        <i
                                          className="fa fa-arrow-down ms-2 fs-12"
                                          style={{ opacity: "0.7" }}
                                        />
                                      ) : (
                                        <i
                                          className="fa fa-arrow-up ms-2 fs-12"
                                          style={{ opacity: "0.7" }}
                                        />
                                      ))}
                                  </span>
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {showLoading ? (
                              <tr>
                                <td colSpan={9}>Loading companies...</td>
                              </tr>
                            ) : null}
                            {!showLoading && companies.length === 0 ? (
                              <tr>
                                <td colSpan={9}>No companies found</td>
                              </tr>
                            ) : null}
                            {companies.map((data, ind) => (
                              <tr key={data.id || ind}>
                                {/* <td>
                                  <img
                                    className="rounded-circle"
                                    width="35"
                                    src={data.profile}
                                    alt=""
                                  />{" "}
                                </td> */}
                                <td style={{ textTransform: "capitalize" }}>
                                  {data.name}
                                </td>
                                <td style={{ textTransform: "capitalize" }}>
                                  {data.category}
                                </td>
                                <td style={{ textTransform: "capitalize" }}>
                                  {data.city}
                                </td>
                                {/* <td style={{ textTransform: "capitalize" }}>
                                  {data.education}
                                </td>
                                <td>
                                  <Link to={"#"}>
                                    <strong>{data.mobile}</strong>
                                  </Link>
                                </td>
                                <td>
                                  <Link to={"#"}>
                                    <strong>{data.email}</strong>
                                  </Link>
                                </td>
                                <td>{data.join}</td> */}
                                {/* <td>
                                  <div className="d-flex align-items-center gap-2">
                                    <button
                                      type="button"
                                      className="btn btn-xs btn-outline-info"
                                      title="View Certificates"
                                      onClick={() =>
                                        setCertModal({
                                          show: true,
                                          docs: data.documents,
                                          name: data.name,
                                        })
                                      }
                                    >
                                      <i className="fa fa-certificate me-1" />
                                      Certificates
                                    </button>
                                    <Switch
                                      onChange={() => handleToggleStatus(data)}
                                      checked={data.companyStatus}
                                      disabled={togglingId === data.id}
                                      onColor="#4d6542"
                                      offColor="#ff5e5e"
                                      uncheckedIcon={false}
                                      checkedIcon={false}
                                      height={22}
                                      width={44}
                                    />
                                  </div>
                                </td> */}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                          <div className="dataTables_info">
                            Showing {showingFrom} to {showingTo} of {total}{" "}
                            entries
                          </div>
                          <div
                            className="dataTables_paginate paging_simple_numbers"
                            id="example5_paginate"
                          >
                            <Link
                              className={`paginate_button previous ${page <= 1 ? "disabled" : ""}`}
                              to="#"
                              onClick={() => page > 1 && setPage(page - 1)}
                            >
                              Previous
                            </Link>
                            <span>
                              {paggination.map((number, i) => (
                                <Link
                                  key={i}
                                  to="#"
                                  className={`paginate_button  ${
                                    page === number ? "current" : ""
                                  } `}
                                  onClick={() => onClick(i)}
                                >
                                  {number}
                                </Link>
                              ))}
                            </span>
                            <Link
                              className={`paginate_button next ${page >= totalPages ? "disabled" : ""}`}
                              to="#"
                              onClick={() =>
                                page < totalPages && setPage(page + 1)
                              }
                            >
                              Next
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab.Pane>
              <Tab.Pane eventKey="Grid" className="col-lg-12">
                <div className="row">
                  {gridDataBlog.map((item, ind) => (
                    <div
                      className="col-lg-4 col-md-6 col-sm-6 col-12"
                      key={ind}
                    >
                      <div className="card card-profile">
                        <div className="card-header justify-content-end pb-0 border-0">
                          <Dropdown>
                            <Dropdown.Toggle
                              as="button"
                              className="btn btn-link i-false"
                              type="button"
                            >
                              <span className="dropdown-dots fs--1"></span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                              align="end"
                              className="dropdown-menu dropdown-menu-right border py-0"
                            >
                              <div className="py-2">
                                <Link to={"#"} className="dropdown-item">
                                  Edit
                                </Link>
                                <Link
                                  to={"#"}
                                  className="dropdown-item text-danger"
                                >
                                  Delete
                                </Link>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <div className="card-body pt-2">
                          <div className="text-center">
                            <div className="profile-photo">
                              <img
                                src={item.image}
                                width="100"
                                className="img-fluid rounded-circle"
                                alt=""
                              />
                            </div>
                            <h3 className="mt-4 mb-1">{item.name}</h3>
                            <p className="text-muted">{item.subject}</p>
                            <ul className="list-group mb-3 list-group-flush">
                              {item.content.map((data, ind) => (
                                <li
                                  className="list-group-item px-0 d-flex justify-content-between"
                                  key={ind}
                                >
                                  <span className="mb-0">{data.title} :</span>
                                  <strong>{data.subtitle}</strong>
                                </li>
                              ))}
                            </ul>
                            <Link
                              to={"/consultant-profile"}
                              className="btn btn-outline-primary btn-rounded mt-3 px-4"
                            >
                              Read More
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </Row>
      <Modal
        show={certModal.show}
        onHide={() => setCertModal({ show: false, docs: [], name: "" })}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Certificates — {certModal.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {certModal.docs.length === 0 ? (
            <p className="text-muted mb-0">No certificates uploaded.</p>
          ) : (
            <ul className="list-group list-group-flush">
              {certModal.docs.map((doc, i) => (
                <li
                  key={i}
                  className="list-group-item px-0 d-flex justify-content-between align-items-center"
                >
                  <span>
                    <i className="fa fa-file-pdf-o me-2 text-danger" />
                    {doc.name || `Document ${i + 1}`}
                  </span>
                  {doc.url && (
                    <a
                      href={doc.url}
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-xs btn-outline-primary"
                    >
                      View
                    </a>
                  )}
                </li>
              ))}
            </ul>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setCertModal({ show: false, docs: [], name: "" })}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AllCompanies;
